// ConvertToCanon/artstyles/BaroqueStyle.js
export const applyBaroqueStyle = async (canvas, ctx, setMessage, language) => {
  // 바로크: 극적이고 화려한 표현
  const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  const data = imageData.data;
  
  // 극도의 명암 대비
  for (let i = 0; i < data.length; i += 4) {
    const brightness = (data[i] + data[i + 1] + data[i + 2]) / 3;
    const factor = brightness < 128 ? 0.6 : 1.4;
    
    data[i] = Math.min(255, Math.max(0, data[i] * factor));
    data[i + 1] = Math.min(255, Math.max(0, data[i + 1] * factor));
    data[i + 2] = Math.min(255, Math.max(0, data[i + 2] * factor));
  }
  
  ctx.putImageData(imageData, 0, 0);
};